import React from 'react';

const subscribe = (): (() => void) => () => {};

/**
 * Checks if a component has mounted. This can be used a check to
 * ensure we're running at runtime. Things never mount during SSR.
 * See https://www.joshwcomeau.com/react/the-perils-of-rehydration/
 *
 * False during SSR and hydration, so the first render matches the
 * server-rendered HTML. Components that mount after hydration, e.g. on
 * client-side navigation, get true straight away.
 */
export default function useHasMounted(): boolean {
    return React.useSyncExternalStore(
        subscribe,
        () => true,
        () => false,
    );
}
